import { Modals } from "../../../../src/examples/foundations/ShadowsAndDepth";
import * as React from 'react';
export default {
  Modals,
  React
};